const BaseURL = "https://bapenda.bekasikota.go.id/bapenda-bekasi-backend/";


export default BaseURL;
